import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { urlPath } from "../util/url.js";
import { toIsoString } from "../util/date.js";
import { isValidationError } from "../util/ams.js";
import { newValidationFailedError } from "../errors/errors.js";
var normalizeRentContract = function normalizeRentContract(rentContract) {
  return _objectSpread(_objectSpread({}, rentContract), {}, {
    rentContractProperties: rentContract.rentContractProperties || []
  });
};
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse;
  var api = {
    getRentContract: function () {
      var _getRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var rentContractId, rentContract;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              rentContractId = _ref2.rentContractId;
              _context.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject || (_templateObject = _taggedTemplateLiteral(["v1.1/rentcontract/", ""])), rentContractId)
              });
            case 3:
              rentContract = _context.sent;
              return _context.abrupt("return", normalizeRentContract(rentContract));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getRentContract(_x) {
        return _getRentContract.apply(this, arguments);
      }
      return getRentContract;
    }(),
    createRentContract: function () {
      var _createRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var contractType, coDate, coDateTime, coStationId, ciDate, ciDateTime, ciStationId, pickupStationId, classificationId, rentContract;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              contractType = _ref3.contractType, coDate = _ref3.coDate, coDateTime = _ref3.coDateTime, coStationId = _ref3.coStationId, ciDate = _ref3.ciDate, ciDateTime = _ref3.ciDateTime, ciStationId = _ref3.ciStationId, pickupStationId = _ref3.pickupStationId, classificationId = _ref3.classificationId;
              if (!(coDate && coDateTime)) {
                _context2.next = 3;
                break;
              }
              throw new Error("coDate and coDateTime cannot be set in the same request");
            case 3:
              if (!(ciDate && ciDateTime)) {
                _context2.next = 5;
                break;
              }
              throw new Error("ciDate and ciDateTime cannot be set in the same request");
            case 5:
              _context2.next = 7;
              return amsResponse.getData({
                method: "POST",
                path: "v1.1/rentcontract/create",
                contentType: amsResponse.contentTypes.json,
                body: {
                  coDate: coDate,
                  coDateTime: toIsoString(coDateTime),
                  coStationId: coStationId,
                  ciDate: ciDate,
                  ciDateTime: toIsoString(ciDateTime),
                  ciStationId: ciStationId,
                  pickupStationId: pickupStationId,
                  classificationId: classificationId,
                  rentContractType: contractType
                }
              });
            case 7:
              rentContract = _context2.sent;
              return _context2.abrupt("return", normalizeRentContract(rentContract));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function createRentContract(_x2) {
        return _createRentContract.apply(this, arguments);
      }
      return createRentContract;
    }(),
    updateRentContract: function () {
      var _updateRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var updatedRentContract;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              updatedRentContract = _ref4.updatedRentContract;
              _context3.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.1/rentcontract/update",
                contentType: amsResponse.contentTypes.json,
                body: updatedRentContract
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function updateRentContract(_x3) {
        return _updateRentContract.apply(this, arguments);
      }
      return updateRentContract;
    }(),
    updateRentContractAfterLogin: function () {
      var _updateRentContractAfterLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref5) {
        var rentContractId;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              rentContractId = _ref5.rentContractId;
              return _context4.abrupt("return", amsResponse.getData({
                method: "POST",
                path: "v1.2/rentcontract/updateafterlogin",
                contentType: amsResponse.contentTypes.json,
                body: {
                  id: rentContractId
                }
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function updateRentContractAfterLogin(_x4) {
        return _updateRentContractAfterLogin.apply(this, arguments);
      }
      return updateRentContractAfterLogin;
    }(),
    getTariffOptions: function () {
      var _getTariffOptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
        var rentContractId, tariffOptions;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              rentContractId = _ref6.rentContractId;
              _context5.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: "v1.2/rentcontract/tariffoptions",
                query: {
                  rentContractId: rentContractId
                }
              });
            case 3:
              tariffOptions = _context5.sent;
              return _context5.abrupt("return", tariffOptions || []);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function getTariffOptions(_x5) {
        return _getTariffOptions.apply(this, arguments);
      }
      return getTariffOptions;
    }(),
    getAvailableRentObjectProperties: function () {
      var _getAvailableRentObjectProperties = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref7) {
        var rentContractId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              rentContractId = _ref7.rentContractId;
              return _context6.abrupt("return", amsResponse.getRawBody({
                method: "GET",
                path: "v1.2/rentcontract/AvailableRequestRentObjectPropertyList",
                query: {
                  rentContractId: rentContractId
                }
              }));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function getAvailableRentObjectProperties(_x6) {
        return _getAvailableRentObjectProperties.apply(this, arguments);
      }
      return getAvailableRentObjectProperties;
    }(),
    addRentObjectPropertiesToRentContract: function () {
      var _addRentObjectPropertiesToRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref8) {
        var rentContractId, _ref8$rentObjectPrope, rentObjectProperties, rentContract;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              rentContractId = _ref8.rentContractId, _ref8$rentObjectPrope = _ref8.rentObjectProperties, rentObjectProperties = _ref8$rentObjectPrope === void 0 ? [] : _ref8$rentObjectPrope;
              _context7.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/rentcontract/AddRequestRentObjectProperties",
                contentType: amsResponse.contentTypes.json,
                body: rentObjectProperties.map(function (_ref9) {
                  var id = _ref9.id,
                    propertyValueId = _ref9.value,
                    wwwAnnotation = _ref9.wwwAnnotation;
                  return {
                    id: id,
                    propertyValue: propertyValueId !== undefined ? {
                      propertyValueId: propertyValueId
                    } : undefined,
                    wwwAnnotation: wwwAnnotation,
                    rentcontractId: rentContractId
                  };
                })
              });
            case 3:
              rentContract = _context7.sent;
              return _context7.abrupt("return", normalizeRentContract(rentContract));
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function addRentObjectPropertiesToRentContract(_x7) {
        return _addRentObjectPropertiesToRentContract.apply(this, arguments);
      }
      return addRentObjectPropertiesToRentContract;
    }(),
    removeRentObjectPropertiesFromRentContract: function () {
      var _removeRentObjectPropertiesFromRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref10) {
        var rentContractId, _ref10$rentObjectProp, rentObjectPropertyIds, rentContract;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              rentContractId = _ref10.rentContractId, _ref10$rentObjectProp = _ref10.rentObjectPropertyIds, rentObjectPropertyIds = _ref10$rentObjectProp === void 0 ? [] : _ref10$rentObjectProp;
              _context8.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/rentcontract/RemoveRequestRentObjectProperties",
                contentType: amsResponse.contentTypes.json,
                body: rentObjectPropertyIds.map(function (id) {
                  return {
                    id: id,
                    rentcontractId: rentContractId
                  };
                })
              });
            case 3:
              rentContract = _context8.sent;
              return _context8.abrupt("return", normalizeRentContract(rentContract));
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function removeRentObjectPropertiesFromRentContract(_x8) {
        return _removeRentObjectPropertiesFromRentContract.apply(this, arguments);
      }
      return removeRentObjectPropertiesFromRentContract;
    }(),
    enableDisableInvoiceItem: function () {
      var _enableDisableInvoiceItem = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref11) {
        var rentContractId, invoiceItemId, enabled;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              rentContractId = _ref11.rentContractId, invoiceItemId = _ref11.invoiceItemId, enabled = _ref11.enabled;
              _context9.next = 3;
              return amsResponse.getRawBody({
                method: "POST",
                path: "v1.2/rentcontract/adaptService",
                contentType: amsResponse.contentTypes.json,
                body: {
                  enable: enabled,
                  rentcontractId: rentContractId,
                  invoiceItemId: invoiceItemId
                }
              });
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function enableDisableInvoiceItem(_x9) {
        return _enableDisableInvoiceItem.apply(this, arguments);
      }
      return enableDisableInvoiceItem;
    }(),
    setDriver: function () {
      var _setDriver = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref12) {
        var rentContractId, driver;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              rentContractId = _ref12.rentContractId, driver = _ref12.driver;
              _context10.prev = 1;
              _context10.next = 4;
              return amsResponse.getRawBody({
                method: "POST",
                path: urlPath(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["v1.1/driver/personContractDriver/", ""])), rentContractId),
                contentType: amsResponse.contentTypes.json,
                body: driver
              });
            case 4:
              _context10.next = 11;
              break;
            case 6:
              _context10.prev = 6;
              _context10.t0 = _context10["catch"](1);
              if (!isValidationError(_context10.t0)) {
                _context10.next = 10;
                break;
              }
              throw newValidationFailedError(_context10.t0);
            case 10:
              throw _context10.t0;
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[1, 6]]);
      }));
      function setDriver(_x10) {
        return _setDriver.apply(this, arguments);
      }
      return setDriver;
    }(),
    enableDisableInvoiceItems: function () {
      var _enableDisableInvoiceItems = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref13) {
        var rentContractId, invoiceItems, enabledItemIds;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              rentContractId = _ref13.rentContractId, invoiceItems = _ref13.invoiceItems, enabledItemIds = _ref13.enabledItemIds;
              _context11.next = 3;
              return Promise.all(invoiceItems.map(function (invoiceItem) {
                var isEnabled = invoiceItem.enabled;
                var shouldBeEnabled = enabledItemIds.includes(invoiceItem.id);
                return isEnabled !== shouldBeEnabled ? api.enableDisableInvoiceItem({
                  rentContractId: rentContractId,
                  invoiceItemId: invoiceItem.id,
                  enabled: shouldBeEnabled
                }) : undefined;
              }));
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function enableDisableInvoiceItems(_x11) {
        return _enableDisableInvoiceItems.apply(this, arguments);
      }
      return enableDisableInvoiceItems;
    }(),
    getDeliveryAddress: function () {
      var _getDeliveryAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref14) {
        var rentContractId;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              rentContractId = _ref14.rentContractId;
              return _context12.abrupt("return", amsResponse.getData({
                method: "GET",
                path: urlPath(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["v1.2/rentcontract/delivery/", ""])), rentContractId)
              }));
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function getDeliveryAddress(_x12) {
        return _getDeliveryAddress.apply(this, arguments);
      }
      return getDeliveryAddress;
    }(),
    setDeliveryAddress: function () {
      var _setDeliveryAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref15) {
        var rentContractId, deliveryAddress;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              rentContractId = _ref15.rentContractId, deliveryAddress = _ref15.deliveryAddress;
              _context13.prev = 1;
              _context13.next = 4;
              return amsResponse.getRawBody({
                method: "POST",
                path: urlPath(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["v1.2/rentcontract/delivery/", ""])), rentContractId),
                contentType: amsResponse.contentTypes.json,
                body: deliveryAddress
              });
            case 4:
              _context13.next = 11;
              break;
            case 6:
              _context13.prev = 6;
              _context13.t0 = _context13["catch"](1);
              if (!isValidationError(_context13.t0)) {
                _context13.next = 10;
                break;
              }
              throw newValidationFailedError(_context13.t0);
            case 10:
              throw _context13.t0;
            case 11:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[1, 6]]);
      }));
      function setDeliveryAddress(_x13) {
        return _setDeliveryAddress.apply(this, arguments);
      }
      return setDeliveryAddress;
    }(),
    deleteDeliveryAddress: function () {
      var _deleteDeliveryAddress = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref16) {
        var rentContractId;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              rentContractId = _ref16.rentContractId;
              _context14.next = 3;
              return amsResponse.getRawBody({
                method: "DELETE",
                path: urlPath(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["v1.2/rentcontract/delivery/", ""])), rentContractId)
              });
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function deleteDeliveryAddress(_x14) {
        return _deleteDeliveryAddress.apply(this, arguments);
      }
      return deleteDeliveryAddress;
    }(),
    activatePromocode: function () {
      var _activatePromocode = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref17) {
        var promocode, rentContractId, rentContract;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              promocode = _ref17.promocode, rentContractId = _ref17.rentContractId;
              _context15.next = 3;
              return amsResponse.getData({
                method: "POST",
                path: "v1.2/promocode/activate",
                contentType: amsResponse.contentTypes.json,
                body: {
                  rentcontractid: rentContractId,
                  promocode: promocode
                }
              });
            case 3:
              rentContract = _context15.sent;
              return _context15.abrupt("return", normalizeRentContract(rentContract));
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      function activatePromocode(_x15) {
        return _activatePromocode.apply(this, arguments);
      }
      return activatePromocode;
    }(),
    submitRentContract: function () {
      var _submitRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref18) {
        var rentContractId, creditCardId, contractNote, agbAccepted, rentContract;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              rentContractId = _ref18.rentContractId, creditCardId = _ref18.creditCardId, contractNote = _ref18.contractNote, agbAccepted = _ref18.agbAccepted;
              _context16.next = 3;
              return amsResponse.getData({
                method: "POST",
                path: "v1.1/rentcontract/submit",
                contentType: amsResponse.contentTypes.json,
                body: {
                  rentContractId: rentContractId,
                  agbAccepted: agbAccepted,
                  creditCardId: creditCardId,
                  contractNote: contractNote
                }
              });
            case 3:
              rentContract = _context16.sent;
              return _context16.abrupt("return", normalizeRentContract(rentContract));
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      function submitRentContract(_x16) {
        return _submitRentContract.apply(this, arguments);
      }
      return submitRentContract;
    }(),
    cancelRentContract: function () {
      var _cancelRentContract = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref19) {
        var rentContractId;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              rentContractId = _ref19.rentContractId;
              _context17.next = 3;
              return amsResponse.getData({
                method: "POST",
                path: "v1.1/rentcontract/cancel",
                contentType: amsResponse.contentTypes.json,
                body: {
                  id: rentContractId
                }
              });
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function cancelRentContract(_x17) {
        return _cancelRentContract.apply(this, arguments);
      }
      return cancelRentContract;
    }()
  };
  return api;
};